<section id="history" class="page-banner parallax-section">
    <div class="container-fluid text-center">
        <div class="row">
            <!-- <div class=" wow fadeInLeft col-md-1">
                <div class="d-flex" style="height: 100px;">
                    <div class="vr"></div>
                  </div>
            </div> -->
            <div class="wow fadeInUp offset-md-3 col-md-6 col-sm-7 " data-wow-delay="0.6s">
                <h1>General Information</h1>
                <ul>
                  <li>
                    <a routerlink="/" href="/">Home</a>
                  </li>
                  <li>General Information</li>
                </ul>
            </div>
        </div> 
    </div>
</section>

<div id="general-info">
    <div class="container">
        <div class="pb-5">
            <h2>General Information</h2>
            <div class="hr"></div>
            <ul class="ml-5">
                <li> License No. : DMW-024-LB-03072023-R</li>
                <li> SEC Registration No. : 89864</li>
                <li> SSS Registration No. : 03-8762811-8</li>
                <li> Tax Identification No. : 000-323-147-000</li>
                <li> Certificates/Licenses</li>
                <li> Chairman and CEO : Joel P. Longares</li>
                <li> Company Name : 7107 Islands 
                Placement and Promotions, Inc.</li>
                <li> Type of Organization : Corporation</li>
                <li> Type of Business : Recruitment and Placement Agency</li>
                <li> Date Established : November 28, 1979</li>
                <li> Business Address : Lot 2&4, Block 6, 
                BF Homes Martinville Portion II,
                Manuyo Dos, Las Pinas City, 
                Philippines 1744</li>
                <li> Office Telephone and fax No. : 02-86810239</li>
                <li> Website/Banking Facilities : www.my7107.com / Metropolitan Bank
                and Trust Company, Equitable PCI Bank 
                Coastal Mall, Paranaque City, 
                Metropolitan Bank and Trust Company, 
                Sucat-Gatchalian Branch, 
                Banco De Oro, One E-Com Center, 
                Palm Coast Avenue, Mall of Asia Complex, 
                Pasay City</li>
            </ul>
        </div>
        <div>
            <h2>Deployment Track Record </h2>
            <div class="hr"></div>
            <ol type="I">
                <li><strong>Our Deployed Highly Skilled Workers and Professionals</strong>
                    <ul>
                        <li>Engineers in all Disciplines, including Engineering Consultancy and
                            Design.</li>
                        <li>Construction Engineers for Power, Petrochemical and pharmaceutical
                                plants, including engineers for buildings, roads and bridges.</li>
                        <li> Medical professionals, Hotel and Restaurant, and Manufacturing
                            Company workers.</li>
                    </ul>

                </li>
                <li><strong>Our Global Business Partners </strong>
                    <ul>
                        <li>Abalto LLC / Abalto Energy Oil and Gas Solutions – Oman</li>
                        <li>Hiap Seng Engineering Ltd. – Singapore</li>
                        <li>Samsung C&T Corporation – Korea and Middle East</li>
                        <li>Samsung Heavy Industries – Korea and some of its projects in the
                        Middle East, Africa and Asia. </li>
                        <li>Hyundai Engineering – Korea and some of its projects in the Middle
                        East, Africa and Asia</li>
                        <li>Hyundai Heavy Industries – Korea and some of its projects in the
                        Middle East, Africa and Asia</li>
                        <li>Dorsch Gruppe Consulting – UAE and Saudi Arabia</li>
                        <li>Metrix Qatar W.L.L. – Qatar</li>
                        <li>Imco Engineering and Construction Co. – Qatar</li>
                        <li>Symkoh, Toyo Breeze, Kholion Kiko Company, Ltd, - Japan</li>
                        <li>Largan Precision Company, Ltd.</li>
                        <li>Crowne Plaza – Qatar</li>
                        <li>Hilton Doha</li>
                        <li>Pullman Doha West Bay Hotel</li>
                        <li>Hilton Hotel</li>
                        <li>Prime Qatar (Group of Restaurants)</li>
                        <li>Sumsum Sweets Qatar and Wonderful Life</li>
                        <li>Tim Hortons (Canada)</li>
                        <li>Trout Canada</li>
                        <li>Sea Drift Canada</li>
                        <li>St. Jeans Canada</li>
                        <li>NHS Hospital (UK)</li>
                        <li>Medline Recruitment
                            <ol type="a">
                                <li>Kent and Canterburry Hospital</li>
                                <li>Queen Elizabeth the Queen Mother Hospital</li>
                                <li>William Harvey Hospital</li>
                            </ol>
                        </li>
                        <li>Ministry of Interior (MOI Hospital) KSA
                            <ol>
                                <li>Security Forces Hospital (Makkah, KSA)</li>
                            </ol>
                        </li>
                        <li>Ministry of Defense (MODA Hospitals) KSA
                            <ol type="a">
                                <li> King Salman Armed Forces Hospital</li>
                                <li> King Khalid Military City Hospital</li>
                                <li> King Fahd Armed Forces Hospital</li>
                                <li> Armed Forces Hospital, Southern Region. Khamis,Mushait, KSA</li>
                                <li> Prince Sultan Military Medical City</li>
                                <li> Sharurah Armed Forces Hospital</li>
                                <li> Armed Forces Hospital, King Adul Aziz Airbase</li>
                                <li> Najran Armed Forces Gospital</li>
                            </ol>
                        </li>
                        <li><strong> To what countries were our workers deployed?</strong></li>
                        <li>Asian Countries – Singapore, Malaysia, China, Vietnam, Thailand,
                        Brunei, Japan, Taiwan, Hong Kong, South Korea, Cambodia</li>
                        <li>Western Countries – Belgium, Canada, United Kingdom, Australia</li>
                        <li>Central Europe – Poland, Croatia, Germany</li>
                        <li>Middle East Country – United Arab Emirates, Qatar, Bahrain, Saudi
                        Arabia, Kuwait, Oman</li>
                        <li>Africa – Tanzania, Nigeria, Ghana, Madagascar, South Sudan, Angola,
                        Ethiopia, Mozambique, Libya, Cote d’Ivore, South Afric </li>
                    </ul>
                </li>
            </ol>
        </div>
    </div>
</div>